import React from "react";
import {
  Button,
  Grid,
  Group,
  Select,
  Textarea,
  TextInput,
} from "@mantine/core";
import { useForm, zodResolver } from "@mantine/form";
import { z } from "zod";
import { useLeaveAdd } from "api/leave/addLeave";
import { useUser } from "hooks/useUser";
import { toIsoWithOffset } from "utils/dateFormater";

const today = new Date().toISOString().split("T")[0];
export const addLeaveSchema = z
  .object({
    leaveType: z.string().trim().min(1, { message: "Please enter leave type" }),
    fromDate: z
      .string()
      .trim()
      .min(1, { message: "Please enter leave from date" })
      .refine(
        (val) => {
          const selected = new Date(val);
          const current = new Date(new Date().toDateString());
          return selected >= current;
        },
        { message: "Holiday date cannot be in the past" }
      ),
    toDate: z
      .string()
      .trim()
      .min(1, { message: "Please enter leave to date" })
      .refine(
        (val) => {
          const selected = new Date(val);
          const current = new Date(new Date().toDateString());
          return selected >= current;
        },
        { message: "Holiday date cannot be in the past" }
      ),
    reason: z.string().trim().min(1, { message: "Please enter leave reason" }),
  })
  .refine(
    (data) => {
      const start = new Date(data.fromDate);
      const end = new Date(data.toDate);
      return start <= end;
    },
    {
      message: "End date must be the same as or after the start date",
      path: ["toDate"],
    }
  );

type AddHolidayFormProps = { onClose: () => void };

export default function AddLeaveRequestForm({ onClose }: AddHolidayFormProps) {
  const { user } = useUser();
  const { mutate: addLeave, isLoading } = useLeaveAdd();

  const form = useForm({
    initialValues: {
      leaveType: "personal",
      fromDate: "",
      toDate: "",
      reason: "",
    },
    validate: zodResolver(addLeaveSchema),
  });

  type FormValues = typeof form.values;

  const handleSubmit = (values: FormValues) => {
    const payload = {
      ...values,
      fromDate: toIsoWithOffset(values.fromDate),
      toDate: toIsoWithOffset(values.toDate),
    };
    addLeave(payload, {
      onSuccess: () => onClose(),
    });
  };

  return (
    <form onSubmit={form.onSubmit(handleSubmit)}>
      <Grid>
        <Grid.Col span={12}>
          <Select
            withAsterisk
            label="Select Leave Type"
            placeholder="Pick or type a leave type"
            data={[
              "sick",
              "annual",
              "personal",
              "maternity",
              "paternity",
              "emergency",
              "unpaid",
              "other",
            ]}
            {...form.getInputProps("leaveType")}
          />
        </Grid.Col>

        <Grid.Col span={6}>
          <Textarea
            withAsterisk
            label="Policy Name"
            placeholder="Policy Name"
            {...form.getInputProps("reason")}
          />
        </Grid.Col>
        <Grid.Col span={6}>
          <Textarea
            withAsterisk
            label="No Of Days"
            placeholder="Policy Name"
            {...form.getInputProps("reason")}
          />
        </Grid.Col>
      </Grid>

      <Group position="right" spacing={20} mt={20}>
        <Button variant="outline" onClick={onClose}>
          Cancel
        </Button>
        <Button type="submit" variant="filled" loading={isLoading}>
          Save
        </Button>
      </Group>
    </form>
  );
}
